<template>
	<div class="goods-list" v-loading="loading">
		<template v-if="panicBuyingList.length > 0">
			<div class="goods-item" v-for="(item, index) in panicBuyingList" :key="index" @click="handlePro(item)">
				<div class="countdown">
					<div class="time" v-if="item.activityStatus != 2">
						<template v-if="item.activityStatus == 0">
							<span>开抢时间</span>
							<span class="time-box">{{
                  sn_formatDate(
                    new Date(item.enableStartTime.replace(/-/g, "/")),
                    "MM月dd"
                  )
                }}&nbsp;{{
                  sn_formatDate(
                    new Date(item.enableStartTime.replace(/-/g, "/")),
                    "HH:mm"
                  )
                }}-{{
                  sn_formatDate(
                    new Date(item.enableEndTime.replace(/-/g, "/")),
                    "HH:mm"
                  )
                }}</span>
						</template>
						<template v-if="item.activityStatus == 1">
							<span>距结束还有</span>
							<span class="time-box">{{ item.remain.h }}</span>
							<span class="time-ico">:</span>
							<span class="time-box">{{ item.remain.m }}</span>
							<span class="time-ico">:</span>
							<span class="time-box">{{ item.remain.s }}</span>
						</template>
					</div>
					<div class="time" v-else>
						<span>抢购已结束</span>
					</div>
					<span class="status" v-if="item.activityStatus == 0">未开始</span>
					<span class="status" v-if="item.activityStatus == 1">抢购中</span>
					<span class="status" v-if="item.activityStatus == 2">已结束</span>
				</div>
				<div class="goods-info">
					<img class="goods-img" :src="item.pic" alt="商品图" />
					<div class="goods-desc">
						<p class="name">
							{{ item.productTypeName }}
						</p>
						<!-- <p class="limit">限购{{ Math.max(0, item.count - item.sales) }}件</p> -->
						<div class="price-progress" v-if="item.activityStatus == 0">
							<!-- 不足百分之10 上取整 大于百分之十 下取整 -->
							<div class="progress">
								<div class="progress-bar" :style="{ width: 0 }"></div>
							</div>
							<div class="progress-text">已抢0%</div>
						</div>
						<div class="price-progress" v-else>
							<!-- 不足百分之10 上取整 大于百分之十 下取整 -->
							<div class="progress">
								<div class="progress-bar" :style="{
                    width:
                      item.sales > item.count
                        ? '100%'
                        : percent(item.sales, item.count) + '%',
                  }"></div>
							</div>
							<div class="progress-text">
								已抢{{
                  item.sales > item.count
                    ? "100"
                    : percent(item.sales, item.count)
                }}%
							</div>
						</div>
						<div class="buy-price-btn">
							<p class="price">
								￥{{ item.buyPrice }}
								<del>￥{{ item.price }}</del>
							</p>
							<template v-if="item.sales >= item.count && item.activityStatus == 1">
								<button class="buy-btn">已抢光</button>
							</template>
							<template v-else>
								<button class="buy-btn" v-if="item.activityStatus == 0">
									即将开抢
								</button>
								<button class="buy-btn" v-if="item.activityStatus == 1">
									马上抢
								</button>
								<button class="buy-btn" v-if="item.activityStatus == 2">
									已结束
								</button>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="pagination-box">
				<el-pagination layout="prev, pager, next" :total="total" @current-change="handleCurrent"
					:current-page="current" :page-size="20">
				</el-pagination>
			</div>
		</template>
		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
	import Cookies from "js-cookie";
	import {
		serverTimeApi,
		panicBuyingApi
	} from "@/api/goods.js";
	export default {
		data() {
			return {
				timer: null, // 定时器ID，用于清除
				total: 0, // 总页数
				current: 1, // 当前页码
				loading: false,
				serverTime: null,
				panicBuyingList: [], // 商品列表
			};
		},
		beforeDestroy() {
			// 组件销毁前清除定时器，避免内存泄漏
			clearInterval(this.timer);
		},
		beforeMount() {
			if (Cookies.get("goodsListData")) {
				let goodsListData = JSON.parse(Cookies.get("goodsListData"));
				this.current = goodsListData.current;
				Cookies.remove("goodsListData");
				this.panicBuying();
			} else {
				this.panicBuying();
			}
		},
		computed: {
			percent() {
				return (sales, count) => {
					return parseFloat((100 * sales) / parseInt(count)) < 10 ?
						Math.ceil(parseFloat((100 * sales) / parseInt(count))) :
						Math.floor(parseFloat((100 * sales) / parseInt(count))) < 100 ?
						Math.floor(parseFloat((100 * sales) / parseInt(count))) :
						100;
				};
			},
		},
		methods: {
			// 倒计时计算
			startCountdown() {
				this.timer = setInterval(() => {
					// 使用服务器时间作为基准时间
					const now = this.serverTime; // 使用服务器时间

					this.panicBuyingList.forEach((item) => {
						if (item.activityStatus == 1) {
							const enableEndTime = new Date(item.enableEndTime).getTime();
							const diff = enableEndTime - now;

							if (diff <= 0) {
								item.remain = {
									h: "00",
									m: "00",
									s: "00"
								};
								item.activityStatus = 2;
							} else {
								const h = Math.floor(diff / (1000 * 60 * 60)) % 24;
								const m = Math.floor(diff / (1000 * 60)) % 60;
								const s = Math.floor(diff / 1000) % 60;

								// 格式化为两位数
								item.remain = {
									h: h.toString().padStart(2, "0"),
									m: m.toString().padStart(2, "0"),
									s: s.toString().padStart(2, "0"),
								};
							}
						}
						if (item.activityStatus == 0) {
							const enableStartTime = new Date(item.enableStartTime).getTime();
							const diff = enableStartTime - now;

							if (diff <= 0) {
								const endTimeOrg = new Date(item.enableEndTime).getTime() - now
								const h = Math.floor(endTimeOrg / (1000 * 60 *
									60)) % 24;
								const m = Math.floor(endTimeOrg / (1000 *
									60)) % 60;
								const s = Math.floor(endTimeOrg / 1000) % 60;

								// 格式化为两位数
								item.remain = {
									h: h.toString().padStart(2, "0"),
									m: m.toString().padStart(2, "0"),
									s: s.toString().padStart(2, "0"),
								};
								// <!--activityStatus 0 未开始 1 进行中 2 已结束 -->
								item.activityStatus = 1;
							}
						}
					});

					// 每秒更新一次服务器时间（假设服务器时间是准确的）
					this.serverTime += 1000;
				}, 1000);
			},
			// 数据分页加载
			handleCurrent(e) {
				this.current = e;
				this.panicBuying();
				clearInterval(this.timer);
			},
			// 获取服务器时间
			onServerTime() {
				serverTimeApi().then((res) => {
					if (res?.code == 0 && res?.data) {
						this.serverTime = new Date(res.data).getTime();
					}
				});
			},
			// 获取商品列表数据
			panicBuying() {
				let params = {
					current: this.current,
					size: 20,
				};
				this.loading = true;
				panicBuyingApi(params).then(async (res) => {
					this.loading = false;
					if (res?.code == 0 && res?.data) {
						await this.onServerTime();
						this.total = res.data.total;
						const list = res.data.records.map((item) => {
							this.$set(item, "remain", {
								h: "00",
								m: "00",
								s: "00"
							});
							return item;
						});
						this.panicBuyingList = list;
						this.startCountdown();
					}
				});
			},
			// 跳转详情页
			handlePro(el) {
				if (el.activityStatus == 1 && el.sales < el.count) {
					let params = {
						current: this.current,
					};
					Cookies.set("goodsListData", params);
					this.$router.push("/goodsDetail?id=" + el.productTypeCode);
				} else if (el.activityStatus == 0) {
					this.$message({
						message: "活动还未开始，请您耐心等待！",
						type: "warning",
					});
				} else if (el.activityStatus == 2) {
					this.$message({
						message: "活动已结束！",
						type: "warning",
					});
				}
			},
		},
	};
</script>

<style lang="scss">
	.goods-list {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.el-empty {
		margin: auto;
	}

	.goods-item {
		width: 595px;
		border-radius: 8px;
		overflow: hidden;
		cursor: pointer;
		background: #ffffff;
		box-sizing: border-box;

		.countdown {
			height: 40px;
			padding: 0 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 16px;
			color: #262728;
			background: linear-gradient(90deg, #ffe7e5 100%);

			.time {
				display: flex;
				align-items: center;

				.time-box {
					display: inline-block;
					padding: 0 4px;
					width: auto;
					height: 24px;
					color: #fff;
					margin-left: 8px;
					margin-right: 8px;
					line-height: 24px;
					text-align: center;
					border-radius: 6px;
					background: #ff3b3a;
				}

				.time-ico {
					height: 24px;
					line-height: 17px;
					color: #c0c4cc;
					font-size: 22px;
				}
			}

			.status {
				float: right;
				font-weight: bold;
				font-size: 16px;
				color: #ff3b3a;
			}
		}

		.goods-info {
			display: flex;
			padding: 14px 20px 20px 20px;

			.goods-img {
				width: 100px;
				height: 100px;
				margin-right: 14px;
				border-radius: 8px;
				background: #ffffff;
				border: 1px solid #edeff2;
			}

			.goods-desc {
				flex: 1;
				line-height: 1;

				.name {
					line-height: 1.3;
					font-size: 18px;
					color: #262728;
					margin-bottom: 10px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					max-width: 100%;
				}

				.limit {
					display: inline-block;
					padding: 0 4px;
					height: 22px;
					line-height: 20px;
					font-size: 14px;
					color: #ff6642;
					text-align: center;
					background: #fff6ed;
					border-radius: 4px 4px 4px 4px;
					border: 1px solid #ff6642;
					margin-bottom: 10px;
				}

				.price-progress {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 15px;

					.progress {
						width: 83%;
						height: 12px;
						overflow: hidden;
						background-color: #eee;
						border-radius: 10px;

						.progress-bar {
							height: 100%;
							background-color: #ffd633;
							border-radius: 10px;
						}
					}

					.progress-text {
						width: 17%;
						font-size: 15px;
						color: #515253;
						text-align: right;
						margin-bottom: 3px;
					}
				}

				.buy-price-btn {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.price {
						font-weight: 500;
						font-size: 22px;
						color: #ff3e3b;
						margin-right: 7px;

						del {
							font-size: 16px;
							color: #909399;
						}
					}

					.buy-btn {
						background-color: #ffcc00;
						padding: 13px 27px;
						border-radius: 8px;
						font-weight: bold;
						font-size: 16px;
						cursor: pointer;
						color: #262728;
						border: none;
					}
				}
			}
		}
	}

	.pagination-box {
		width: 100%;
		text-align: center;

		.el-pagination {
			margin: 50px auto;

			.btn-prev,
			.btn-next,
			.el-pager li {
				background: none !important;
				height: 28px;
				line-height: 28px;
				font-weight: 400;
			}

			.el-pager li.active {
				background: #fece36 !important;
				color: #262728;
				border-radius: 8px;
				min-width: 28px;
				font-weight: bold;
			}
		}
	}
</style>